import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const getConfigList = data => post(URL.GET_SYSTEM_CONFIGURATION, data);

